import React from 'react';
import PropTypes from 'prop-types';
import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import { VF_MULTI_SELECT } from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select';
import { VF_SUB_SECTION_TITLE, VFSubSectionTitle } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';
import { VF_PARAGRAPH, VFParagraph } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';
import { VF_TIME_STAMP } from 'AppSrc/core/components/forms/form-base-components/utility/v-f-time-stamp';
import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import { VF_MODAL } from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import { VF_RADIO_BUTTON } from 'AppSrc/core/components/forms/form-base-components/v-f-radio-button';
// import { VF_SINGLE_RADIO } from 'AppSrc/core/components/forms/form-base-components/v-f-single-radio';
// import { VF_EDIT_TABLE, VFEditTable } from 'AppSrc/core/components/forms/form-base-components/v-f-edit-table';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { SummaryVFDatePicker } from 'AppSrc/core/components/forms/form-base-components/summary-components/summary-v-f-date-picker';
import { SummaryVFCorrectiveDatePicker } from 'AppSrc/core/components/forms/form-base-components/summary-components/summary-v-f-corrective-date-picker';
import { SummaryVFButtonSelector } from './summary-v-f-button-selector';
import { SummaryVFDropdown } from './summary-v-f-dropdown';
import { SummaryVFMultiSelect } from './summary-v-f-multi-select';
import { SummaryVFTextarea } from './summary-v-f-textarea';
import { SummaryVFModal } from './summary-v-f-modal';
import { SummaryVFInput } from './summary-v-f-input';
import { VF_CORRECTIVE_DATE_PICKER } from '../v-f-corrective-date-picker';
// import { SummaryVFSingleRadio } from './summary-v-f-single-radio';

// this can be displayed differently depending on the type of input.
const summaryFieldTypes = {
  [VF_BUTTON_SELECTOR]: SummaryVFButtonSelector,
  // NOTE: VF_DROPDOWN uses SummaryVFButtonSelector as a temporary measure. SummaryVFButtonSelector works for simple
  // drop downs, but in future we will have to make SummaryVFDropdown to handle the more complex data structures
  // for NameCards ect
  [VF_DROPDOWN]: SummaryVFDropdown,
  [VF_TEXTAREA]: SummaryVFTextarea,
  [VF_INPUT]: SummaryVFInput,
  [VF_MODAL]: SummaryVFModal,
  [VF_DATE_PICKER]: SummaryVFDatePicker,
  [VF_MULTI_SELECT]: SummaryVFMultiSelect,
  [VF_CORRECTIVE_DATE_PICKER]: SummaryVFCorrectiveDatePicker,
  // coming soon!
  [VF_TIME_STAMP]: null, // This is only used in work information item at the moment, might never need a summary component
  [VF_RADIO_BUTTON]: null, // NOT FULLY IMPLEMENTED YET!
  // this is not really a form field!
  [VF_SUB_SECTION_TITLE]: VFSubSectionTitle,
  [VF_PARAGRAPH]: VFParagraph,
};

const SectionCompletionReviewSummary = React.memo(({
  formSection,
  selectedNetwork,
  formData,
}) => (
  <div className="section-summary">
    <ul className="summary-fields">
      {
        formSection.map(({ componentData }) => {
          const {
            id,
            vFParams,
          } = componentData;
          const fieldData = formData[id] || { ...componentData, ...vFParams };
          const {
            fieldType,
            hideFromSummary,
            vFTypeSpecificOptions,
          } = fieldData;

          const FieldSummary = summaryFieldTypes[fieldType];

          if (hideFromSummary) {
            return null;
          }

          if (!FieldSummary) {
            return null;
          }

          return (
            <li className="summary-field" key={id}>
              <FieldSummary
                fieldData={fieldData}
                vFParams={vFParams}
                selectedNetwork={selectedNetwork}
                formData={formData}
                vFTypeSpecificOptions={vFTypeSpecificOptions}
              />
            </li>
          );
        })
      }
    </ul>
  </div>
));


SectionCompletionReviewSummary.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formSection: PropTypes.array,
  formData: formDataShape,
  selectedNetwork: PropTypes.string,
};



export { SectionCompletionReviewSummary };
